import { logger } from "@scott/logger";

const isDebugEnabled = process.env.NEXT_PUBLIC_DEBUG === "true";

export function debugInfo(...args: unknown[]) {
  if (!isDebugEnabled) {
    return;
  }
  logger.log("[DEBUG]", ...args);
}

export function debugWarn(...args: unknown[]) {
  if (!isDebugEnabled) {
    return;
  }
  logger.warn("[DEBUG]", ...args);
}

export function debugError(...args: unknown[]) {
  if (!isDebugEnabled) {
    return;
  }
  logger.error("[DEBUG]", ...args);
}
